import { DrillPageSentenceRating } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._components.sentence-rating";
import type { DrillPageSentenceDrill } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._lib.sentence-drill";
import { useSentenceDrillRatingMutation } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._lib.sentence-drill";

/**
 * Connects the sentence-drill rating row to the batch-rating mutation.
 *
 * Split from the presentational row so the row stays free of context and mutations — the drill page
 * is the only thing that knows which card is being drilled.
 */
export function DrillPageSentenceRatingFooter({
  sentenceDrill: _sentenceDrill,
}: {
  sentenceDrill: DrillPageSentenceDrill;
}) {
  const ratingMutation = useSentenceDrillRatingMutation();

  return (
    <DrillPageSentenceRating
      onRate={(rating) => {
        ratingMutation.mutate(rating);
      }}
      pendingRating={ratingMutation.isPending ? ratingMutation.variables : null}
    />
  );
}
